import { lazy } from 'solid-js'
import { ADD_PROPERTY_SECTION } from '../../components/lodgr/lodgr-add-property-template/add-property-sections-config-constants.js'
import { messages } from '../../pages/property-setup/property-setup-page-routing.messages.en.js'

const common = {
    component: lazy(() => import('../../pages/property-setup/property-setup-page.jsx')),
    requiredMode: 'host',
    showFooter: false,
    showFullWidthHeader: true,
    showHeaderMenu: false,
    showSidebar: false,
    titleMessage: messages.titleMessage,
}

// TODO: these could prob be unified into a single /setup page eventually
export const setupExternal = {
    ...common,
    path: '/property/:property_id/setup-external/:page?',
    props: {
        addPropertySectionKey: ADD_PROPERTY_SECTION.SETUP_EXTERNAL,
    },
    wizardHelpSection: ADD_PROPERTY_SECTION.SETUP_EXTERNAL,
}

export const setupNative = {
    ...common,
    path: '/property/:property_id/setup-native/:page?',
    props: {
        addPropertySectionKey: ADD_PROPERTY_SECTION.SETUP_NATIVE,
    },
    wizardHelpSection: ADD_PROPERTY_SECTION.SETUP_NATIVE,
}
